/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Error_Archiving_JobInputs */

const en_error_archiving_job = /** @type {(inputs: Error_Archiving_JobInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error archiving job: ${i?.error}`)
};

const fr_error_archiving_job = /** @type {(inputs: Error_Archiving_JobInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erreur lors de l’archivage de la tâche : ${i?.error}`)
};

const de_error_archiving_job = /** @type {(inputs: Error_Archiving_JobInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fehler beim Archivierungsauftrag: ${i?.error}`)
};

const it_error_archiving_job = /** @type {(inputs: Error_Archiving_JobInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Errore durante l'archiviazione del lavoro: ${i?.error}`)
};

const ru_error_archiving_job = /** @type {(inputs: Error_Archiving_JobInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ошибка при архивировании задания: ${i?.error}`)
};

const es_error_archiving_job = /** @type {(inputs: Error_Archiving_JobInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error al archivar el trabajo: ${i?.error}`)
};

const zh_cn2_error_archiving_job = /** @type {(inputs: Error_Archiving_JobInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`归档作业出错：${i?.error}`)
};

const ja_error_archiving_job = /** @type {(inputs: Error_Archiving_JobInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`アーカイブジョブ中にエラーが発生しました: ${i?.error}`)
};

const hi_error_archiving_job = /** @type {(inputs: Error_Archiving_JobInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`आर्काइविंग जॉब में त्रुटि: ${i?.error}`)
};

const pt_pt2_error_archiving_job = /** @type {(inputs: Error_Archiving_JobInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erro ao arquivar tarefa: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Error archiving job: {error}" |
*
* @param {Error_Archiving_JobInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_archiving_job = /** @type {((inputs: Error_Archiving_JobInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Archiving_JobInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_error_archiving_job(inputs)
	if (locale === "de") return de_error_archiving_job(inputs)
	if (locale === "it") return it_error_archiving_job(inputs)
	if (locale === "ru") return ru_error_archiving_job(inputs)
	if (locale === "es") return es_error_archiving_job(inputs)
	if (locale === "zh-CN") return zh_cn2_error_archiving_job(inputs)
	if (locale === "ja") return ja_error_archiving_job(inputs)
	if (locale === "hi") return hi_error_archiving_job(inputs)
	if (locale === "pt-PT") return pt_pt2_error_archiving_job(inputs)
	return en_error_archiving_job(inputs)
});